import { playConversation, rotatePromptWords } from './animation';

const initializeConversation = (root: HTMLElement) => {
    if (root.dataset.initialized || root.classList.contains('is-editor')) return;
    root.dataset.initialized = 'true';
    const trigger = root.querySelector<HTMLElement>('.stgb-ai-conversation__prompt');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let entrance: IntersectionObserver | undefined;
    let stop: (() => void) | undefined;
    let stopWords: (() => void) | undefined;
    let hasPlayed = false;

    const configure = () => {
        entrance?.disconnect();
        stop?.();
        stopWords?.();
        root.dataset.motion = 'complete';
        // Keep the finished conversation visible for the rest of this page load,
        // including after a visitor changes their reduced-motion preference.
        if (!trigger || root.dataset.animate === 'false' || reducedMotion.matches) return;
        if (hasPlayed || !('IntersectionObserver' in window)) {
            stopWords = rotatePromptWords(root);
            return;
        }

        root.dataset.motion = 'waiting';
        entrance = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting || hasPlayed || root.dataset.motion !== 'waiting') return;
                hasPlayed = true;
                entrance?.disconnect();
                stop = playConversation(root);
                stopWords = rotatePromptWords(root);
            });
        }, {
            // Match Sidekick's column entrance trigger. Observing the prompt
            // also works when a long result list is taller than the viewport.
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.15,
        });
        entrance.observe(trigger);
    };

    reducedMotion.addEventListener('change', configure);
    configure();
};

const initialize = () => document.querySelectorAll<HTMLElement>('.stgb-ai-conversation').forEach(initializeConversation);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
else initialize();
